export default "__VITE_ASSET__CZ4i5EDo__"